import { motion } from 'framer-motion';

import { isMobile } from 'react-device-detect';

import { useAuthStore } from '@/stores/userStore';
import { getCurrencySymbol } from '@/utils/currency';

import Confetti from './Confetti';

const formatCurrency = (amount: number, currency?: string) => {
  const symbol = getCurrencySymbol(currency ?? 'USD');
  return `${symbol} ${amount.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};

interface PoolPrizeProps {
  amount: number;
}

const PoolPrize = ({ amount }: PoolPrizeProps) => {
  const { account } = useAuthStore();
  
  return (
    <div className="p-0 w-full h-full flex items-center justify-center relative">
      <Confetti />
      <div
        className={`${isMobile ? 'p-4' : 'p-6'} relative z-10 w-full h-full flex items-center justify-center`}
        style={{ '--scale': '1' } as React.CSSProperties}
      >
        <motion.div
          className={`${isMobile ? 'text-5xl' : 'text-7xl'} font-extrabold text-yellow-300 drop-shadow-2xl`}
          style={{
            scale: 'var(--scale)',
            textShadow: '0 0 10px rgba(0,0,0,0.5), 0 0 20px rgba(255,255,0,0.3)',
          }}
          animate={{
            scale: [1, 1.05, 1],
            rotate: [0, 1, -1, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        >
          {formatCurrency(amount, account?.currency)}
        </motion.div>
      </div>
    </div>
  );
};

export default PoolPrize;
